import cf from './cf';
import i16v from './i16v_20211024';

export default class i16v1a extends i16v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'i16v1a';
    this.d_viewDefs = {
      name: 'カテゴリ'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
